import React from 'react';

interface PaginationInfo {
  currentPage: number;
  totalPages: number;
  totalRecords: number;
  limit: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startRecord: number;
  endRecord: number;
}

interface PaginationProps {
  paginationInfo: PaginationInfo;
  chartId: string;
  onPaginationChange: (action: 'next' | 'previous' | 'page', pageNumber?: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ paginationInfo, chartId, onPaginationChange }) => {
  return (
    <div style={{
      position: 'absolute',
      bottom: "12px",
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 20px',
      borderTop: '1px solid #e0e0e0',
      fontSize: '14px',
      color: '#666',
      marginLeft: '5px',
      marginRight: '60px',
      zIndex: 5
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span>
          Showing {paginationInfo.startRecord} to {paginationInfo.endRecord} of {paginationInfo.totalRecords} entries
        </span>
      </div>
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <button
          onClick={() => onPaginationChange('previous')}
          disabled={!paginationInfo.hasPreviousPage}
          style={{
            padding: '5px 10px',
            border: '1px solid #ddd',
            backgroundColor: paginationInfo.hasPreviousPage ? '#fff' : '#f5f5f5',
            color: paginationInfo.hasPreviousPage ? '#333' : '#999',
            cursor: paginationInfo.hasPreviousPage ? 'pointer' : 'not-allowed',
            borderRadius: '4px',
            fontSize: '12px'
          }}
        >
          Previous
        </button>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
          {Array.from({ length: Math.min(5, paginationInfo.totalPages) }, (_, i) => {
            let pageNumber: number;
            if (paginationInfo.totalPages <= 5) {
              pageNumber = i + 1;
            } else if (paginationInfo.currentPage <= 3) {
              pageNumber = i + 1;
            } else if (paginationInfo.currentPage >= paginationInfo.totalPages - 2) {
              pageNumber = paginationInfo.totalPages - 4 + i;
            } else {
              pageNumber = paginationInfo.currentPage - 2 + i;
            }
            
            return (
              <button
                key={pageNumber}
                onClick={() => onPaginationChange('page', pageNumber)}
                disabled={pageNumber === paginationInfo.currentPage}
                style={{
                  padding: '5px 10px',
                  border: '1px solid #ddd',
                  backgroundColor: pageNumber === paginationInfo.currentPage ? '#08305D' : '#fff',
                  color: pageNumber === paginationInfo.currentPage ? '#fff' : '#333',
                  cursor: pageNumber === paginationInfo.currentPage ? 'default' : 'pointer',
                  borderRadius: '4px',
                  fontSize: '12px',
                  minWidth: '35px',
                  opacity: pageNumber === paginationInfo.currentPage ? 0.7 : 1
                }}
              >
                {pageNumber}
              </button>
            );
          })}
        </div>
        
        <button
          onClick={() => onPaginationChange('next')}
          disabled={!paginationInfo.hasNextPage}
          style={{
            padding: '5px 10px',
            border: '1px solid #ddd',
            backgroundColor: paginationInfo.hasNextPage ? '#fff' : '#f5f5f5',
            color: paginationInfo.hasNextPage ? '#333' : '#999',
            cursor: paginationInfo.hasNextPage ? 'pointer' : 'not-allowed',
            borderRadius: '4px',
            fontSize: '12px'
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
